import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  articles,
  categories,
  hotTopics,
  getHotArticles,
  getTopArticles,
} from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import SchemaOrg from "@/components/base/SchemaOrg";

export default function Home() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => (prev >= 156789 ? 156789 : prev + 123));
    }, 80);
    return () => clearInterval(timer);
  }, []);

  const hotArticles = getHotArticles(6);
  const topArticles = getTopArticles(2);
  const latestArticles = articles.slice(0, 6);

  return (
    <>
      <SchemaOrg
        type="WebSite"
        title="吃瓜网51 | 51吃瓜网app下载最快免费观看，全网吃瓜黑料每日实时更新"
        description="下载51吃瓜网app，享受最快最全的免费吃瓜体验。每日实时更新全网网红黑料、明星八卦与今日大瓜，高清视频流畅观看，吃瓜群众必备神器，马上下载加入爆料盛宴！"
      />
      <SchemaOrg
        type="Organization"
        title="吃瓜网51"
        description="全网最快最全的免费吃瓜爆料平台"
      />

      {/* Hero Section */}
      <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden bg-background-950">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20red%20and%20black%20abstract%20newsroom%20atmosphere%2C%20glowing%20red%20spotlights%20piercing%20through%20dark%20smoke%2C%20mysterious%20silhouettes%20of%20crowd%20watching%2C%20cinematic%20dark%20moody%20background%2C%20abstract%20digital%20gossip%20news%20energy%2C%20high%20contrast%20editorial%20art&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
            alt="吃瓜网51背景"
            className="w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
        </div>
        <div className="relative z-10 w-full px-4 md:px-8 pt-24 md:pt-28 pb-16 md:pb-20">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-sm font-medium mb-6">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
              今日已有 {count.toLocaleString()} 人在吃瓜
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-4 md:mb-6">
              全网吃瓜黑料
              <br />
              <span className="text-primary-400">每日实时更新</span>
            </h1>
            <p className="text-base md:text-lg text-background-200 max-w-xl mx-auto mb-8 leading-relaxed">
              下载51吃瓜网app，享受最快最全的免费吃瓜体验。网红黑料、明星八卦、今日大瓜一网打尽，高清视频流畅观看，吃瓜群众必备神器！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#download"
                className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-primary-500 text-background-50 text-base font-bold hover:bg-primary-600 transition-all shadow-lg shadow-primary-500/25 whitespace-nowrap"
              >
                <i className="ri-download-line w-5 h-5 flex items-center justify-center" />
                立即下载App
              </a>
              <Link
                to="/category/today-hot"
                className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-background-50/10 border border-background-200/30 text-background-50 text-base font-semibold hover:bg-background-50/20 transition-all backdrop-blur-sm whitespace-nowrap"
              >
                <i className="ri-compass-line w-5 h-5 flex items-center justify-center" />
                探索今日大瓜
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Hot Topics Marquee */}
      <section className="w-full py-4 bg-background-100 border-y border-background-200/70">
        <div className="w-full px-4 md:px-8 flex items-center gap-4 overflow-hidden">
          <span className="shrink-0 px-3 py-1.5 rounded bg-primary-500 text-background-50 text-xs font-bold flex items-center gap-1.5">
            <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center" />
            热搜榜
          </span>
          <div className="flex items-center gap-6 overflow-x-auto no-scrollbar">
            {hotTopics.slice(0, 6).map((topic) => (
              <Link
                key={topic.id}
                to={topic.link}
                className="shrink-0 flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                <span className="w-5 h-5 rounded bg-accent-100 text-accent-700 text-xs font-bold flex items-center justify-center">
                  {topic.id}
                </span>
                {topic.title}
                <span className="text-xs text-foreground-400">
                  {(topic.heat / 10000).toFixed(0)}万热度
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Top News / Featured */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
              重磅爆料
            </h2>
            <p className="text-sm text-foreground-500">
              全网最劲爆的吃瓜热点，第一手独家爆料
            </p>
          </div>
          <Link
            to="/category/today-hot"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看更多
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {topArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group relative rounded-2xl overflow-hidden aspect-[16/10] bg-background-100"
            >
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded bg-primary-500 text-background-50 text-xs font-bold mb-3">
                  {article.hotTag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-background-50 group-hover:text-primary-300 transition-colors leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-background-200 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Latest Articles */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
              最新吃瓜
            </h2>
            <p className="text-sm text-foreground-500">刚刚更新的爆料内容，速来围观</p>
          </div>
          <Link
            to="/category/today-hot"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看更多
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </section>

      {/* Categories */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium mb-4">
            探索分类
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            吃瓜分类矩阵
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            六大热门分类，覆盖全网所有吃瓜领域，你想看的这里都有
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative rounded-2xl overflow-hidden aspect-square bg-background-100"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-black/50 group-hover:bg-black/40 transition-colors" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-3">
                <h3 className="text-base md:text-lg font-bold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <span className="text-xs text-background-300">
                  {cat.articleCount}篇爆料
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Hot Trending */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
              吃瓜热点
            </h2>
            <p className="text-sm text-foreground-500">当前最热门的吃瓜话题，全民都在讨论</p>
          </div>
          <Link
            to="/category/today-hot"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看更多
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </section>

      {/* Download CTA */}
      <section
        id="download"
        className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-950"
      >
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-400/40 text-primary-300 text-sm font-medium mb-6">
            立即下载
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-background-50 leading-tight mb-4">
            下载51吃瓜网App
            <br />
            <span className="text-primary-400">享受极致吃瓜体验</span>
          </h2>
          <p className="text-base text-background-300 max-w-2xl mx-auto mb-8 leading-relaxed">
            每日实时更新全网网红黑料、明星八卦与今日大瓜，高清视频流畅观看，支持离线缓存，随时随地想看就看。吃瓜群众必备神器，马上下载加入爆料盛宴！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-background-50 text-foreground-950 text-base font-bold hover:bg-background-100 transition-colors shadow-lg whitespace-nowrap">
              <i className="ri-apple-fill w-6 h-6 flex items-center justify-center text-xl" />
              <div className="text-left">
                <div className="text-xs font-normal text-foreground-500">下载</div>
                <div className="text-sm font-bold">iOS版本</div>
              </div>
            </button>
            <button className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-primary-500 text-background-50 text-base font-bold hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/25 whitespace-nowrap">
              <i className="ri-android-fill w-6 h-6 flex items-center justify-center text-xl" />
              <div className="text-left">
                <div className="text-xs font-normal text-primary-200">下载</div>
                <div className="text-sm font-bold">Android版本</div>
              </div>
            </button>
          </div>
          <p className="mt-6 text-xs text-background-500">
            支持iOS 12+ / Android 8.0+ | 完全免费 | 无广告干扰
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {[
            { num: "500万+", label: "累计用户下载", icon: "ri-download-line" },
            { num: "10万+", label: "每日爆料更新", icon: "ri-article-line" },
            { num: "99.8%", label: "用户好评率", icon: "ri-emotion-happy-line" },
            { num: "24h", label: "全天候实时更新", icon: "ri-time-line" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="text-center p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/70"
            >
              <i
                className={`${stat.icon} w-8 h-8 flex items-center justify-center text-primary-500 text-2xl mx-auto mb-3`}
              />
              <div className="text-2xl md:text-3xl font-black text-foreground-950 mb-1">
                {stat.num}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}